// Utilities
import CreditCard from '../../utility/creditCardUtil'

import { defaultObj } from './state'

export default {
  getPayDebitCardsSuccess (state, cardsData) {
    state.paymentCards = cardsData.cards
    if (cardsData.validations) {
      state.validations = cardsData.validations
    }
  },

  addPayDebitCardSuccess (state, cardData) {
    state.paymentCards.push({
      cardToken: cardData.cardToken,
      cardIds: cardData.cardIds,
      cardNumber: cardData.cardNumber,
      cardType: cardData.cardType,
      cardholderName: cardData.cardholderName,
      customerId: cardData.customerId,
      customerIds: cardData.customerIds,
      expirationMonth: cardData.expirationMonth,
      expirationYear: cardData.expirationYear,
      guestCard: cardData.guestCard,
      newCard: cardData.newCard,
      canDisburse: cardData.canDisburse === true
    })
  },

  updateCard (state, { cardIds, isGuestCard }) {
    const card = state.paymentCards.find(card => CreditCard.isSameCard(cardIds, card.cardIds))

    card.guestCard = isGuestCard
  },

  removePayDebitCardSuccess (state, cardsData) {
    state.paymentCards = state.paymentCards.filter(card => {
      return CreditCard.isSameCard(cardsData.cardIds, card.cardIds) === false
    })
  },

  setTokenPayInstance (state, tokenPayInstance) {
    state.tokenPayInstance = tokenPayInstance
  },

  setTempBridgePayToken (state, tempToken) {
    state.bridgePayToken = tempToken
  },

  setRepayTokenInfo (state, repayTokenInfo) {
    state.repayTokenInfo = repayTokenInfo
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
